import { useEffect, useRef, useState } from "react";

import { ReactComponent as LogOutIcon } from "../../images/log_out.svg";

import LanguageSelector from "../Items/Selectors/LanguageSelector";
import AccessForm from "../Items/Forms/AccessForm";
import LightDarkButton from "../Items/Buttons/LightDarkButton";

export default function Header({ localization, language, setLanguage, accessFormState, state, theme, setTheme, createAccess, onLogOut }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const headerRef = useRef(null);

  // Закрытие по клику вне Header
  useEffect(() => {
    if (!menuOpen) return;

    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <header ref={headerRef} className="header flex-row">
      <h2 className="header__title">EDE Server</h2>

      <div className={`header__actions-menu ${menuOpen ? "header__actions-menu--open" : ""}`}>
        <LightDarkButton theme={theme} setTheme={setTheme} />

        <LanguageSelector language={language} setLanguage={setLanguage} />

        <button className="header__button access-button button uppercase" type="button" onClick={accessFormState} disabled={state}>
          {localization.newAccess[language]}
        </button>

        <button className="header__button action-button button uppercase flex-row" type="button" onClick={onLogOut}>
          <LogOutIcon className="action-button__icon" />
        </button>

        <AccessForm
          localization={localization}
          accessFormState={accessFormState}
          state={state}
          language={language}
          onSubmit={createAccess}
        />
      </div>
    </header>
  );
}
